import React, {useState} from 'react';
import {Box, Button, Collapse, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {LlmAssessmentResponse} from '../../../../store/models/DuplicateCheck';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
    },
    pre: {
        margin: theme.spacing(0.5, 0, 1.5),
        padding: theme.spacing(1),
        backgroundColor: theme.palette.grey[100],
        fontSize: 12,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        maxHeight: 400,
        overflow: 'auto',
    },
    errorText: {
        color: theme.palette.error.main,
    },
}));

export default function LlmRawPanel({response}: {response: LlmAssessmentResponse}) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    const usage = response.usage;
    return (
        <Box className={classes.root}>
            <Button size="small" onClick={() => setExpanded((e) => !e)}>
                {expanded ? 'Rohantwort ausblenden' : 'Rohantwort anzeigen'}
            </Button>
            <Collapse in={expanded} timeout="auto">
                <Box mt={1} pl={1}>
                    <Typography variant="body2">
                        Modell: <b>{response.target.model}</b> ({response.target.baseUrl}), Dauer: {response.durationMs} ms
                        {usage && (
                            <>, Tokens: {usage.promptTokens ?? '?'} Prompt / {usage.completionTokens ?? '?'} Antwort</>
                        )}
                    </Typography>
                    {response.parseError && (
                        <Typography variant="body2" className={classes.errorText}>
                            Antwort nicht parsebar: {response.parseError}
                        </Typography>
                    )}
                    <Box mt={1}>
                        <Typography variant="body2"><b>Rohantwort</b></Typography>
                        <pre className={classes.pre}>{response.rawContent}</pre>
                    </Box>
                </Box>
            </Collapse>
        </Box>
    );
}
